'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function date(language) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var formatter = new Intl.DateTimeFormat(language, format);
  return function (value) {
    return formatter.format(value);
  };
}

function number(language) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var formatter = new Intl.NumberFormat(language, format);
  return function (value) {
    return formatter.format(value);
  };
}

exports.date = date;
exports.number = number;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lingui-formats/dist/index.js
// module id = 682
// module chunks = 2